import { render, staticRenderFns } from "./interDeparment.vue?vue&type=template&id=6b458316&scoped=true"
import script from "./interDeparment.vue?vue&type=script&lang=js"
export * from "./interDeparment.vue?vue&type=script&lang=js"
import style0 from "./interDeparment.vue?vue&type=style&index=0&id=6b458316&prod&lang=scss&scoped=true"
import style1 from "./interDeparment.vue?vue&type=style&index=1&id=6b458316&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b458316",
  null
  
)

export default component.exports